export enum DomainTypeEnum {
  ENS = 'ENS',
  LNR = 'LNR',
}
